import React from "react";
import { AuthConsumer } from "./AuthProvider";
import ManyosSpinner from "../ManyosSpinner/ManyosSpinner";

export const LogoutCallback = () => (
    <AuthConsumer>
        {({ signoutRedirectCallback }) => {
            signoutRedirectCallback();
            return <ManyosSpinner/>;
        }}
    </AuthConsumer>
);
